<style>
.medical-document__exam-name {
  color: #000000;
  display: inline-block;
  font-family: 'Open Sans';
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: normal;
  margin-left: 1rem;
  text-transform: capitalize;
}
</style>

<template>
  <article class="medical-document">
    <print-header
      type="Pedido de Exame"
      :date="$moment(active['created_at']).format('DD/MM/YYYY')"
      :patient="patient"
      :doctor="doctor"
    />

    <p class="medical-document__info-title">
      Nome do exame
      <span class="medical-document__exam-name">
        {{active['medical_service'].name}}
      </span>
    </p>

    <p class="medical-document__info-title">
      Observações
    </p>

    <div v-html="active.note" />

    <print-footer :doctor="doctor" />
  </article>
</template>

<script>
import printHeader from './_header.vue'
import printFooter from './_footer.vue'

export default {
  name: 'DrPrintTemplateExam',

  components: {
    printHeader,
    printFooter
  },

  props: ['formData', 'active', 'patient', 'doctor']
}
</script>
